import React, {useRef, useState, useEffect} from 'react';
import Autocomplete from 'react-autocomplete';

import ButtonSelect from '../ui/ButtonSelect';
import IconSelect from '../icons/IconSelect';

import './index.css';

const BaseSelect = (props) => {
  const selectRef = useRef(null);
  const [value, setValue] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const autocompleteRef = useRef(null);

  const toggleSelect = (e) => {
    setIsOpen(!isOpen);
    document.body.addEventListener('click', closeSelect);
    e.stopPropagation();
  };

  const closeSelect = (e) => {
    if (!selectRef.current.contains(e.target)) {
      setIsOpen(false);
      document.body.removeEventListener('click', closeSelect);
    }
  }

  const selectOption = (value, d) => {
    props.selectOption(props.selectOptions.prop, value);
    setIsOpen(false);
  }

  const matchStateToTerm = (state, value) => {
    const optionText = typeof state === 'string' ? state : props.getText(state);
    return optionText.toLowerCase().indexOf(value.toLowerCase()) !== -1;
  } 

  useEffect(() => {
    if (isOpen) autocompleteRef.current.focus();
  }, [isOpen])

  const selectClassName = props.selectClassName ? props.selectClassName + ' form__input form__select-input' : 'form__input form__select-input';
  const inputPlaceholder = props.inputPlaceholder;
  const optionsListWidth = props.optionsListWidth ? props.optionsListWidth : '26rem';

  return (
    <div className={`base-autocomplete ${props.className}`} ref={selectRef}>
      {
        props.type === 'select' &&
        <div className="base-autocomplete__input-wrapper">
          <input 
            className={selectClassName}
            value={props.value} 
            readOnly 
            onChange={props.changeValue}
            placeholder={props.inputButtonPlaceholder ? props.inputButtonPlaceholder : "Choose One"}
            onFocus={toggleSelect} 
            id={props.inputId}
          />
          {props.isShowSelectIcon && <IconSelect className="base-autocomplete__icon"/>}
        </div>
      }
      {
        props.type === 'button' &&
        <ButtonSelect name={props.name} onClick={toggleSelect}/>
      }
      {
        isOpen && 
        <div className="base-autocomplete__data" style={{width: optionsListWidth}}>
          <Autocomplete
            ref={autocompleteRef}
            getItemValue={(item) => item}
            value={value}
            shouldItemRender={matchStateToTerm}
            onChange={(e) => setValue(e.target.value)}
            onSelect={(val) => selectOption(val)}
            items={props.selectOptions.options}
            className="base-autocomplete__autocomplete"
            inputProps={{onBlur: () => setIsOpen(false)}}
            onMenuVisibilityChange={(isOpen) => !isOpen && setIsOpen(false)}
            renderInput={
              function(props) {
                return <input {...props} className="base-autocomplete__input" placeholder={inputPlaceholder}/>
              }
            }
            renderMenu={children => (
              <div className="base-autocomplete__list">
                {children}
              </div>
            )}
            renderItem={
              (item, isHighlighted) =>
              <div
                key={props.getText ? item.UUID : item}
                className={
                  `base-autocomplete__item 
                  ${isHighlighted ? 'base-autocomplete__item--highlighted' : ''}`
                }
              >
                {props.getText ? props.getText(item) : item}
              </div>
            }
          />
        </div>
      }
    </div>
  );
}

export default BaseSelect;
